import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getJwtToken } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const jwtTokenService = createAsyncThunk(
    'fetchPreAuthFAF', getJwtToken
)

const initialState = {
    jwtToken: "",
    jwt: "",
    loader: false
}

const jwtTokenSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetJwtToken: (state) => {
            state.jwtToken = ""
            state.loader = false
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(jwtTokenService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(jwtTokenService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(jwtTokenService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetJwtToken } = jwtTokenSlice.actions

export default jwtTokenSlice.reducer